import type { Source } from '@painpal/contracts';
import { File } from 'lucide-react';
import styles from './SourceGlyph.module.css';

export function SourceGlyph({ source }: { source: Source }) {
  return (
    <span className={styles.glyph} data-source={source} role="img" aria-label={source === 'fit' ? 'FIT file' : 'Strava'}>
      {source === 'fit' ? <File size={10} aria-hidden="true" /> : 'S'}
    </span>
  );
}
